import axios from "axios";
import API from './api';

const inviteService = {
    getInviteList(inviteNumber, pageIndex) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${API.localhost}/v1/order/GetAllInviteInfo`,
                params: {
                    inviteNumber,
                    pageIndex
                }
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    modifyCashAvailable(invitePhone, cashAvailable, AuthorizationCode) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${API.localhost}/v1/order/ModifyInviteCashAvailableResource`,
                params: {
                    invitePhone,
                    cashAvailable,
                    AuthorizationCode
                }
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            })
        })
    }
}

export { inviteService }